(function () {
  'use strict';

  var SCRIPT_ID = 'blankwall-umd-cjs';
  var BLANKWALL_SRC = 'https://dfv2bs0cn166o.cloudfront.net/blankwall.umd.cjs';
  var SIZE_ATTR = 'data-selected-size';
  var initialized = false;

  function readBoyutFromDom() {
    var labels = document.querySelectorAll('variant-selects label, variant-radios label, .product-form__input label');
    for (var i = 0; i < labels.length; i++) {
      var txt = (labels[i].textContent || '').trim();
      if (/^(boyut|size|ölçü|olcu)/i.test(txt)) {
        var fieldset = labels[i].closest('fieldset') || labels[i].parentElement;
        if (!fieldset) continue;
        var checked = fieldset.querySelector('input:checked');
        if (checked) {
          var valEl = fieldset.querySelector('[data-value="' + checked.value + '"]') || checked.nextElementSibling;
          if (valEl && valEl.textContent) return valEl.textContent.trim();
          return checked.value;
        }
        var select = fieldset.querySelector('select');
        if (select && select.value) return select.options[select.selectedIndex].text.trim();
      }
    }
    var desc = document.querySelector('.blankwall-product-description');
    return desc ? desc.textContent.trim() : '';
  }

  function normalizeSize(sizeStr) {
    if (!sizeStr) return '';
    var s = String(sizeStr).trim();
    var dim = s.match(/(\d+(?:[.,]\d+)?)\s*[x×X]\s*(\d+(?:[.,]\d+)?)/);
    if (dim) return dim[1].replace(',', '.') + 'x' + dim[2].replace(',', '.') + ' cm';
    return s;
  }

  function readSelectedSize() {
    var fromBody = normalizeSize(document.body.getAttribute(SIZE_ATTR));
    if (fromBody) return fromBody;
    return normalizeSize(readBoyutFromDom());
  }

  function syncSize() {
    var val = readSelectedSize();
    if (val) document.body.setAttribute(SIZE_ATTR, val);
    var desc = document.querySelector('.blankwall-product-description, .product-description');
    if (desc && val) desc.textContent = val;
  }

  function loadBlankwall(cb) {
    if (window.Blankwall) return cb();
    if (document.getElementById(SCRIPT_ID)) {
      var wait = setInterval(function () {
        if (window.Blankwall) {
          clearInterval(wait);
          cb();
        }
      }, 100);
      setTimeout(function () {
        clearInterval(wait);
        cb();
      }, 10000);
      return;
    }
    var s = document.createElement('script');
    s.id = SCRIPT_ID;
    s.async = true;
    s.src = BLANKWALL_SRC;
    s.onload = cb;
    s.onerror = cb;
    document.head.appendChild(s);
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    url = url.replace(/-\d+x\d+(?=\.\w+$)/, '');
    url = url.replace(/_\d+x(?=\.\w+$)/, '');
    try {
      var u = new URL(url, location.origin);
      /*
        Perf: eskiden tüm parametreler siliniyordu ve tarayıcı baskı
        master'ını (2+ MB) indiriyordu. AR duvar önizlemesi için 2048px
        fazlasıyla keskin; CDN'den DPR-doğru boyut istenir, kalite
        algısı değişmez.
      */
      u.search = '';
      u.searchParams.set('width', '2048');
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  function activeSlideImage() {
    var img =
      document.querySelector('.product__media-item.swiper-slide-active .pfp-art') ||
      document.querySelector('.product__media-item.swiper-slide-active .product__media img') ||
      document.querySelector('.product__media-item .pfp-art') ||
      document.querySelector('.product__media-item .product__media img');
    if (!img) return null;
    var src = img.currentSrc || img.src || img.getAttribute('src') || '';
    return src ? { src: src, element: img } : null;
  }

  function ensureHiddenImg() {
    var img = document.querySelector('img.blankwall-product-image, img.product-image');
    if (!img) {
      img = document.createElement('img');
      img.className = 'product-image blankwall-product-image';
      img.alt = '';
      img.hidden = true;
      document.body.appendChild(img);
    }
    /*
      Perf: 2048px görsel (~1MB+) yalnızca blankwall gerçekten
      başlatıldıktan sonra indirilsin. Varyant değişimi vb. yollarla
      erken çağrılırsa src atlanır; startBlankwall içindeki döngü ve
      düğme tıklaması zaten tekrar çağırır.
    */
    if (!blankwallStarted) return img;
    var hero = activeSlideImage();
    if (hero && hero.src) {
      var clean = normalizeImageUrl(hero.src);
      if (img.src !== clean) img.src = clean;
    }
    return img;
  }

  function ensureContainer() {
    var container = document.getElementById('blankwall-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'blankwall-container';
      document.body.appendChild(container);
    }
    return container;
  }

  function ensureDims() {
    var dims = document.querySelector('.blankwall-product-description, .product-description');
    if (!dims) {
      dims = document.createElement('div');
      dims.className = 'product-description blankwall-product-description';
      dims.hidden = true;
      document.body.appendChild(dims);
    }
    syncSize();
    return dims;
  }

  function initBlankwall() {
    if (initialized) return true;
    ensureContainer();
    ensureDims();
    ensureHiddenImg();

    var imageEl = document.querySelector('img.blankwall-product-image, img.product-image[src]');
    if (!window.Blankwall || !imageEl) return false;

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 639px)').matches;
    var style = isMobile
      ? { buttonText: 'Duvarında gör', width: '100%', padding: '12px 16px', borderRadius: '0px' }
      : { buttonText: 'Duvarında gör' };

    window.Blankwall.init(
      {
        ar_container_selector: '#blankwall-container',
        ar_image_selector: 'img.blankwall-product-image, img.product-image',
        ar_dimensions_selector: '.blankwall-product-description, .product-description',
        auto_crop: false,
      },
      style
    );

    initialized = true;
    document.dispatchEvent(new CustomEvent('blankwall:ready'));
    return true;
  }

  function bindViewButton() {
    document.querySelectorAll('.blankwall-art-button').forEach(function (btn) {
      if (btn.dataset.blankwallBound) return;
      btn.dataset.blankwallBound = '1';
      btn.addEventListener('click', function () {
        startBlankwall();
        syncSize();
        ensureHiddenImg();
        var arBtn = document.querySelector('#blankwall-container .ar-button');
        if (arBtn) {
          arBtn.click();
          return;
        }
        var tries = 0;
        var retry = setInterval(function () {
          syncSize();
          ensureHiddenImg();
          var found = document.querySelector('#blankwall-container .ar-button');
          if (found) {
            clearInterval(retry);
            found.click();
          } else if (++tries > 40) {
            clearInterval(retry);
          }
        }, 250);
      });
    });
  }

  function bindVariantBridge() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var variant = payload && payload.data && payload.data.variant;
      if (!variant) return;
      var size = '';
      if (variant.options && variant.options.length) {
        for (var i = 0; i < variant.options.length; i++) {
          var v = variant.options[i];
          if (/\d/.test(v) && /x|×/i.test(v)) {
            size = v;
            break;
          }
        }
        if (!size) {
          for (var j = 0; j < variant.options.length; j++) {
            if (/cm|mm|in/i.test(variant.options[j])) {
              size = variant.options[j];
              break;
            }
          }
        }
        if (!size) size = variant.title;
      }
      if (size) {
        document.body.setAttribute(SIZE_ATTR, size);
        var desc = document.querySelector('.blankwall-product-description, .product-description');
        if (desc) desc.textContent = size;
      }
      setTimeout(ensureHiddenImg, 250);
    });
  }

  function bindGallerySync() {
    document.querySelectorAll('.product__media-list .js-media-list').forEach(function (slider) {
      if (slider._blankwallBound || !slider.swiper) return;
      slider._blankwallBound = true;
      slider.swiper.on('slideChangeTransitionEnd', function () {
        ensureHiddenImg();
        document.dispatchEvent(new CustomEvent('blankwall:ready'));
      });
    });
  }

  var blankwallStarted = false;
  function startBlankwall() {
    if (blankwallStarted) return;
    blankwallStarted = true;
    loadBlankwall(function () {
      var tries = 0;
      var iv = setInterval(function () {
        syncSize();
        ensureHiddenImg();
        bindGallerySync();
        if (initBlankwall() || ++tries > 48) clearInterval(iv);
      }, 250);
    });
  }

  /*
    Perf: AR kütüphanesi (CloudFront) ve gizli 2048px görsel (~1MB+)
    artık otomatik (idle) BAŞLATILMAZ — her PDP ziyaretinde etkileşim
    olmasa bile 1.2MB indiriliyordu. İlk kullanıcı etkileşiminde
    (dokunma/kaydırma/klavye) ısıtılır; "Duvarında gör" düğmesi zaten
    startBlankwall'ı anında çağırır. İşlev aynı kalır.
  */
  function scheduleBlankwall() {
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, startBlankwall, { once: true, passive: true });
    });
  }

  function boot() {
    bindViewButton();
    bindVariantBridge();
    syncSize();
    bindGallerySync();

    scheduleBlankwall();

    setTimeout(bindGallerySync, 800);
    setTimeout(bindGallerySync, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
